import { Inline } from '@etg/wings';
import { Icon } from '@eti/components';
import { css } from '@eti/styles';
import { constants } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import type { IncludedCabinBaggage, IncludedCheckedBaggage } from '@eti/schema-types';
import { getBaggageWeightText } from '../trip-details/utils/format';

const baggageIconStyles = css`
  flex-shrink: 0;
`;

export interface ItineraryBaggageInfoProps {
  includedCabinBaggage: IncludedCabinBaggage;
  includedCheckedBaggage: IncludedCheckedBaggage;
}

const ItineraryBaggageInfo = ({
  includedCabinBaggage,
  includedCheckedBaggage,
}: ItineraryBaggageInfoProps) => {
  const { t } = useTranslation();

  const {
    unicodeControlCharacters: { LRE, PDF },
  } = constants;

  const isCabinBaggageIncluded = Boolean(includedCabinBaggage?.pieces);
  const cabinBaggageContent = isCabinBaggageIncluded
    ? t(
        'TripDetails.CabinBaggageIncludedBound.Text',
        `${LRE}${getBaggageWeightText(includedCabinBaggage as any)}${PDF}`,
      )
    : t('TripDetails.CabinBaggage.NotIncluded.Text');

  const isCheckedBaggageIncluded = Boolean(includedCheckedBaggage?.weight);
  const checkedBaggageContent = isCheckedBaggageIncluded
    ? t(
        'TripDetails.BaggageIncludedBound',
        `${LRE}${getBaggageWeightText(includedCheckedBaggage as any)}${PDF}`,
      )
    : t('TripDetails.BaggageNotIncluded');
  const cabinBaggageIconId = isCabinBaggageIncluded ? 'cabin-baggage' : 'no-cabin-baggage';
  const checkedBaggageIconId = isCheckedBaggageIncluded
    ? 'check-in-baggage'
    : 'no-check-in-baggage';

  return (
    <>
      <Inline alignY="center" noWrap spacing={8}>
        <Icon className={baggageIconStyles} id={cabinBaggageIconId} size="16px" />
        <p data-testid="trip-segment-info-cabinBaggage">{cabinBaggageContent}</p>
      </Inline>
      <Inline alignY="center" noWrap spacing={8}>
        <Icon className={baggageIconStyles} id={checkedBaggageIconId} size="16px" />
        <p data-testid="trip-segment-info-checkedBaggage">{checkedBaggageContent}</p>
      </Inline>
    </>
  );
};

export default ItineraryBaggageInfo;
